// extracted by mini-css-extract-plugin
module.exports = {"buttonholder":"Record_buttonholder__1b4vx","addbutton":"Record_addbutton__192Hb"};